import React from 'react';

const items = [
  { id: 1, name: '₹200 Amazon Voucher', cost: 500 },
  { id: 2, name: '1 Paid Leave', cost: 1000 },
  { id: 3, name: 'Free Lunch', cost: 200 }
];

const RewardsStore = ({ user }) => {
  const points = user?.points ?? 0;

  return (
    <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-4">Rewards Store</h1>

      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm text-gray-500">Points Balance</div>
            <div className="text-2xl font-semibold text-gray-900">{points}</div>
          </div>
          <div>
            <button className="px-3 py-2 bg-indigo-600 text-white rounded-md">View History</button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {items.map(i => (
          <div key={i.id} className="bg-white rounded-lg shadow p-4 text-center">
            <div className="text-sm text-gray-600">{i.name}</div>
            <div className="mt-2 text-lg font-semibold">{i.cost} pts</div>
            <button className="mt-3 px-3 py-2 bg-green-600 text-white rounded-md">Redeem</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RewardsStore;
